<template>
	<AppSkipToContent class="app-skip-to-content" href="#main" />
	<AppNotifications class="app-notifications" />
	<AppLayout>
		<AppBreadcrumbs class="app-breadcrumbs" />

		<TRoute :document-title="$t('global-default-document-title')">
			<RouterView />
		</TRoute>
	</AppLayout>
</template>

<script setup lang="ts">
import TRoute from '@/app/common/TRoute.vue'
import AppBreadcrumbs from '@/shared/global/AppBreadcrumbs.vue'
import AppNotifications from '@/shared/global/AppNotifications.vue'
import AppSkipToContent from '@/shared/global/AppSkipToContent.vue'

import AppLayout from './app/layout/AppLayout.vue'
</script>

<style scoped>
@media print {
	.app-skip-to-content,
	.app-notifications,
	.app-breadcrumbs {
		display: none !important;
	}
}
</style>
